import React, { useEffect } from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { AuthProvider } from "./components/Auth/AuthProvider";
import { SessionProvider } from "./components/SessionProvider";

const accessToken = sessionStorage.getItem("token");
console.log("accessToken ->", accessToken);
//if null than
ReactDOM.render(
  <AuthProvider accessToken={accessToken}>
    {/* <SessionProvider> */}
      <App />
    {/* </SessionProvider> */}
  </AuthProvider>,
  document.getElementById("root")
);

reportWebVitals();
